<template>
  <div class="battery-mgmt">
    <div class="main-title">
      <p v-if="view=='list'" @click="cancelHandle">优惠券</p>
      <p v-if="view=='add'" @click="cancelHandle">优惠券</p>
      <p v-if="view=='add'">>新增</p>
      <p v-if="view=='edit'" @click="cancelHandle">优惠券</p>
      <p v-if="view=='edit'">>编辑</p>
      <p v-if="view=='record'" @click="cancelHandle">优惠券</p>
      <p v-if="view=='record'">>查看优惠券实例</p>
    </div>
    <div class="main-body" v-if="view=='list'">
      <div class="list">
        <span>优惠券模板编号：</span>
        <el-input class="list-input" size="mini" v-model="number" placeholder="请输入优惠券模板编号"></el-input>
        <span class="ml10">优惠券类型：</span>
        <el-select class="fixed-width-150" v-model="type">
          <el-option
            v-for="item in typeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
        <div class="blue-btn ml10" @click="onAddBtnClick">新增</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th width="170px">优惠券编号</th>
          <th>名称</th>
          <th>适用商品</th>
          <th>类型</th>
          <th width="145px">有效期</th>
          <th>状态</th>
          <th width="350px">操作</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="item,index in dataList" :key="index">
          <td>{{ item.number }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.commodityTitle }}</td>
          <td>{{ types[item.type] }}</td>
          <td>{{ item.validBeginTime ? item.validBeginTime + '~' + item.validEndTime : '--' }}</td>
          <td>{{ item.status }}</td>
          <td>
            <div class="text-btn fixed-width-75" @click="onTabBtnClick(item)">切换状态</div>
            <div class="text-btn fixed-width-75" @click="onEditBtnClick(item)">编辑</div>
            <div class="text-btn fixed-width-75" @click="onDeleteBtnClick(item)">删除</div>
            <div class="text-btn fixed-width-100" @click="onRecordBtnClick(item)">查看优惠券实例</div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="7">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
    <div class="main-body" v-if="view == 'add'">
      <discount-add-view @addSuccess="addSuccessHandle" @cancel="cancelHandle"></discount-add-view>
    </div>
    <div class="main-body" v-if="view == 'edit'">
      <discount-edit-view :editData="editData" @editSuccess="editSuccessHandle"
                          @cancel="cancelHandle"></discount-edit-view>
    </div>
    <div class="main-body" v-if="view == 'record'">
      <discount-record-view :editData="editData"></discount-record-view>
    </div>
  </div>
</template>

<script>
import DiscountAddView from "./discountAddView";
import DiscountEditView from "./discountEditView";
import DiscountRecordView from "./discountRecordView";

export default {
  name: 'discount',
  components: {DiscountRecordView, DiscountEditView, DiscountAddView},
  data() {
    return {
      view: "list",
      number: "",
      type: '',
      typeList: [
        {
          id: '',
          text: '全部'
        },
        {
          id: '0',
          text: '满减券'
        }, {
          id: '1',
          text: '折扣券'
        }, {
          id: '2',
          text: '满赠券'
        },
      ],
      types: ['满减券', '折扣券', '满赠券'],
      pageSize: 10,
      beginIndex: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      dataList: [],
      editData: {}
    }
  },
  mounted() {
    if (this.$route.query.number) {
      this.number = this.$route.query.number;
    }
    this.queryCouponsList();
  },
  methods: {
    queryCouponsList: function () {
      let self = this;
      let params = {
        number: this.number,
        type: this.type,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      };
      this.$http.post('/managementPlatform/admin/queryCoupons', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryCouponsList();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryCouponsList();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.queryCouponsList();
    },
    onAddBtnClick() {
      this.view = 'add';
    },
    onEditBtnClick(data) {
      this.view = 'edit';
      this.$nextTick(() => {
        this.editData = data;
      });
    },
    onRecordBtnClick(data) {
      this.view = 'record';
      this.$nextTick(() => {
        this.editData = data;
      });
    },
    addSuccessHandle() {
      this.view = 'list';
      this.beginIndex = 0;
      this.queryCouponsList();
    },
    editSuccessHandle() {
      this.view = 'list';
      this.queryCouponsList();
    },
    cancelHandle() {
      this.view = 'list';
      this.queryCouponsList();
    },
    onTabBtnClick(item) {
      let self = this;
      this.$confirm('确定要切换状态吗？', '提示', {
        type: 'warning'
      }).then(() => {
        self.changeCoupons(item.number);
      }).catch(() => {

      });
    },
    changeCoupons(number) {
      let self = this;
      let params = {
        number: number
      };
      this.$http.post('/managementPlatform/admin/updateCouponsStatus', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "操作失败!",
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "操作成功!",
          center: true
        });
        self.queryCouponsList();
      }).catch(function (response) {
        console.log(response);
      });
    },
    onDeleteBtnClick(item) {
      let self = this;
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        self.deleteCoupons(item.number);
      }).catch(() => {

      });
    },
    deleteCoupons(number) {
      let self = this;
      let params = {
        number: number
      };
      this.$http.post('/managementPlatform/admin/deleteCoupon', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "删除失败!",
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "删除成功!",
          center: true
        });
        self.queryCouponsList();
      }).catch(function (response) {
        console.log(response);
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.main-body {
  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 185px;
    }

    .list-input {
      width: 180px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .fixed-width-200 {
      width: 200px;
    }

    .fixed-width-300 {
      width: 300px;
    }
  }

  .table-custom {
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #417505;
      display: inline-block;
      background-color: #BEE6B3;
      cursor: pointer;
    }

    .fixed-width-75 {
      width: 75px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .mt4 {
      margin-top: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/marketingMgmt/discount.vue